import {
  string as yupString,
  object as yupObject,
  number as yupNumber,
} from 'yup';

export interface StopFormState {
  en_name: string;
  ar_name: string;
  lon: string;
  lat: string;
  stop_code: string;
}

export const STOP_CODE_PATTERN = /^[A-Za-z]+[0-9]+$/;

// Extract the trailing digits of an alphanumeric code (e.g. "ABC123" -> "123").
// The Ruby backend keeps requiring the legacy numeric `code`, so the portal
// derives it from the user-entered `stop_code`.
export const extractNumericCode = (stop_code: string): string => {
  if (!stop_code) return '';

  const match = stop_code.match(/[0-9]+$/);

  return match ? match[0] : '';
};

const StopFormSchema = intl => {
  const validationRequiredMessage = intl.formatMessage({
    id: 'requiredValidation',
  });

  const lonValidateNumberMessage = intl.formatMessage({
    id: 'lonNumberValidation',
  });

  const latValidateNumberMessage = intl.formatMessage({
    id: 'latNumberValidation',
  });

  const stopCodePatternMessage = intl.formatMessage({
    id: 'stopCodeAlphanumeric',
  });

  return yupObject().shape({
    en_name: yupString().required(validationRequiredMessage),
    ar_name: yupString().required(validationRequiredMessage),
    lon: yupNumber()
      .typeError(lonValidateNumberMessage)
      .required(validationRequiredMessage),
    lat: yupNumber()
      .typeError(latValidateNumberMessage)
      .required(validationRequiredMessage),
    stop_code: yupString()
      .required(validationRequiredMessage)
      .matches(STOP_CODE_PATTERN, stopCodePatternMessage),
  });
};

export { StopFormSchema };
